import { render, staticRenderFns } from "./ProjectRatingHistory.vue?vue&type=template&id=15e1ab04&scoped=true&"
import script from "./ProjectRatingHistory.vue?vue&type=script&lang=js&"
export * from "./ProjectRatingHistory.vue?vue&type=script&lang=js&"
import style0 from "styles/dashboard/style.scss?vue&type=style&index=0&id=15e1ab04&scoped=true&lang=css&"
import style1 from "styles/dashboard/datatable.scss?vue&type=style&index=1&id=15e1ab04&scoped=true&lang=css&"
import style2 from "./ProjectRatingHistory.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1ab04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e1ab04')) {
      api.createRecord('15e1ab04', component.options)
    } else {
      api.reload('15e1ab04', component.options)
    }
    module.hot.accept("./ProjectRatingHistory.vue?vue&type=template&id=15e1ab04&scoped=true&", function () {
      api.rerender('15e1ab04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/ProjectRatingHistory.vue"
export default component.exports